<template>
  <div class="task_logs esls-page">
    <div class="public-breadcrumb">
      <router-link style="color: #6e6b7b" to="/">{{
        $t("devices.Welcome")
      }}</router-link>
      > {{ $t("lcd.Devices.DevicesManage") }} >
      <span style="color: #3461ff">{{ $t("MarketingStrategy") }}</span>
    </div>
    <div class="flex-between card-bg esls-page_top device-page_top">
      <div class="flex-between transmit-btn-box">
        <el-button
          size="small"
          class="transmit-btn top-btn"
          @click="handleAdd"
          >{{ $t("lcd.NewAdd.Add MarketingStrategy") }}</el-button
        >
      </div>
    </div>
    <div class="table_set">
      <div class="select_filter">
        <div>
          <span class="text"
            >{{ $t("taskLog.Records") }}:{{ pageParams.total }}</span
          >
          <el-select
            v-model="pageParams.storeType"
            @change="getList"
            size="small"
          >
            <el-option
              v-for="item in storeQueryTypeList"
              :key="item.dictValue"
              :label="item.dictName"
              :value="item.dictValue"
            />
          </el-select>
        </div>
      </div>
      <el-table
        ref="tableRows"
        :data="tableData"
        style="width: 100%"
        class="table-topstyle"
        @select-all="handleSelectAll"
      >
        <el-table-column type="selection" width="50">
          <el-table-column type="selection" />
        </el-table-column>
        <el-table-column align="center" :label="$t('taskLog.Store Name')">
          <el-table-column align="center" prop="storeName" min-width="150">
            <template slot="header">
              <el-input
                clearable
                v-model="pageParams.storeName"
                size="mini"
                @input="getList"
              />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" :label="$t('lcd.NewAdd.MarketingStrategy Name')">
          <el-table-column align="center" prop="scheduleAd" min-width="90">
            <template slot="header">
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          :label="$t('lcd.NewAdd.scheduleType')"
          prop="scheduleType"
          align="left"
        >
          <el-table-column prop="scheduleType" min-width="180">
            <template #header> </template>
            <template slot-scope="scope">
              <span v-if="scope.row.scheduleType == 0">{{
                $t("lcd.Devices.All Device")
              }}</span>
              <div v-if="scope.row.scheduleType == 1">
                {{ $t("lcd.Devices.Define Device") }}：<br />
                <span
                  v-for="item in JSON.parse(scope.row.scheduleEquipment)"
                  :key="item"
                >
                  {{ item }}
                  <br />
                </span>
              </div>
              <div v-if="scope.row.scheduleType == 2">
                {{ $t("lcd.Devices.Define Tag") }}：<br />
                <span
                  v-for="item in JSON.parse(scope.row.scheduleEquipment)"
                  :key="item"
                >
                  {{ getPropertyValue(item) }}
                  <br />
                </span>
              </div>
              <span v-if="scope.row.scheduleType == 3">{{
                $t("lcd.Devices.All No Tag Device")
              }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('lcd.NewAdd.ST')" prop="periodType">
          <el-table-column prop="periodType" min-width="90">
            <template #header>
            </template>
            <template slot-scope="scope">
              <el-tag v-if="scope.row.periodType == 'day'">{{$t('lcd.NewAdd.day')}}</el-tag>
              <div v-if="scope.row.periodType == 'week'">
                <el-tag>{{$t('lcd.NewAdd.week')}}</el-tag>
                <div v-for="item in scope.row.weekDays.split(',').sort()" :key ="item">
                  <span v-if="item == 'SUN'">{{$t('lcd.NewAdd.Sunday')}}</span>
                  <span v-if="item == 'MON'">{{$t('lcd.NewAdd.Monday')}}</span>
                  <span v-if="item == 'TUE'">{{$t('lcd.NewAdd.Tuesday')}}</span>
                  <span v-if="item == 'WED'">{{$t('lcd.NewAdd.Wednesday')}}</span>
                  <span v-if="item == 'THU'">{{$t('lcd.NewAdd.Thursday')}}</span>
                  <span v-if="item == 'FRI'">{{$t('lcd.NewAdd.Friday')}}</span>
                  <span v-if="item == 'SAT'">{{$t('lcd.NewAdd.Saturday')}}</span>
                </div>
              </div>
              <div v-if="scope.row.periodType == 'month'">
                <el-tag>{{$t('lcd.NewAdd.month')}}</el-tag>
                <div>{{scope.row.days}}({{$t('dateRuleDialog.Day')}})</div>
              </div>

              <div v-if="scope.row.periodType == 'year'">
                <el-tag>{{$t('lcd.NewAdd.year')}}</el-tag>
                <div>{{scope.row.months}}({{$t('dateRuleDialog.Month')}})</div>
                <div>{{scope.row.days}}({{$t('dateRuleDialog.Day')}})</div>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('lcd.NewAdd.ST time range')" prop="periodType">
          <el-table-column prop="periodType" min-width="120">
            <template #header>
            </template>
            <template slot-scope="scope">
              {{scope.row.segmentStartTime}} - {{scope.row.segmentEndTime}} 
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" :label="$t('lcd.NewAdd.Template Name')">
          <el-table-column align="center" prop="templateName" min-width="160">
            <template slot="header">
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" :label="$t('lcd.NewAdd.DefaultTemplate Name')">
          <el-table-column align="center" prop="defaultTemplateName" min-width="160">
            <template slot="header">
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('taskLog.Begin time')" prop="startTimeStr">
          <el-table-column prop="startTimeStr" min-width="220">
            <template #header>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('taskLog.End time')" prop="endTimeStr">
          <el-table-column prop="endTimeStr" min-width="220">
            <template #header></template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('taskLog.Status')">
          <el-table-column prop="stateDesc" width="150">
            <template slot="header">
              <el-select
                v-model="pageParams.state"
                placeholder=""
                size="mini"
                clearable
                @change="getList"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.codeId"
                  :label="item.codeName"
                  :value="item.codeId"
                />
              </el-select>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          :label="$t('taskLog.Action')"
          fixed="right"
          width="160"
          header-align="center"
        >
          <el-table-column align="center" width="160">
            <template #header> </template>
            <template slot-scope="scope">
              <!-- 仅进行中的可以终止 -->
              <el-button
                type="text"
                @click="handleEnd(scope.row)"
                style="font-size: 13px"
                v-if="scope.row.state == 4902"
                >{{ $t("lcd.NewAdd.End st") }}</el-button
              >
              <!-- 仅未开始的投放任务可删除投放 -->
              <el-button
                type="text"
                @click="handleDelete(scope.row)"
                style="font-size: 13px"
                v-if="scope.row.state == 4901"
                >{{ $t("lcd.Devices.Delete") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <pagination :tableInfo="pageParams" @changePage="changePage" />
    </div>
    <AddSchedule ref="addScheduleRef" @reGetList="getList"></AddSchedule>

    <!-- 操作确认弹窗 -->
    <confirm-dialog
      :dialogVisible="isVisibleConfirmDialog"
      @handleClose="handelConfirmDialog"
      :confirmObj="confirmObj"
    >
    </confirm-dialog>
  </div>
</template>
<script>
import { commonStore } from "@/store/global-select-store";
import modelUi from "@/views/taskManagement/taskManger/utils/modelUi.js";
import { getCodeList } from "@/libs/api/taskManger.js";
import AddSchedule from "./components/addSchedule";
import {
  parseResp,
  parseError,
} from "@/views/taskManagement/taskManger/utils/requestUtil.js";

import { getStoreId } from "@/views/taskManagement/taskManger/utils/cacheUtil.js";
import pagination from "@/components/pagination";

import {
  ENDST,
  getLcdScheduleList,
  endLcdSchedule,
  deleteLcdSchedule,
  addLcdSchedule,
  updateLcdSchedule,
  getLcdScheduleDetail,
} from "@/libs/api/lcd";
import ConfirmDialog from "@/components/confirm-dialog/index.vue";

export default {
  components: {
    pagination,
    AddSchedule,
    ConfirmDialog,
  },
  data() {
    return {
      isVisibleConfirmDialog: false, // 确认弹窗可见性
      confirmObj: {
        type: this.$t("devices.tips"),
        cancelText: this.$t("devices.cancel"),
        confirmText: this.$t("devices.sure"),
        content: this.$t("lcd.adLaunch.ENDSTTips"),
        loading: false,
      },
      userData: JSON.parse(localStorage.getItem("userData")),
      currentConfirmType: "",
      currentRow: {},
      commonStore,
      stateList: [],
      taskTypeList: [],
      storeQueryTypeList: [
        {
          dictValue: 2,
          dictName: this.$t("ThisStore"),
        },
        {
          dictValue: 1,
          dictName: this.$t("ZimenStore"),
        },
        {
          dictValue: 0,
          dictName: this.$t("AllStore"),
        },
      ],
      leng: "",
      tableData: [],
      pageParams: {
        current: 1,
        size: 10,
        total: 0,
        storeType: 2,
        storeName: "",
        storeId: "",
        state: "",
        orders: [],
      },
      lcdTagOptions: [],
    };
  },
  created() {
    commonStore.setInjectCallBack(this.initPage);
    this.initPage();
  },
  computed: {
    language() {
      return this.$store.state.appConfig.language;
    },
  },
  watch: {
    language(val) {
      if (val) this.initPage();
    },
  },
  methods: {
    // 获取标签多语言描述的值
    getPropertyValue(targetValue) {
      const item = this.lcdTagOptions.find(
        (obj) => obj["codeId"] == targetValue
      );
      return item ? item["codeName"] : "";
    },

    //  页面初始化
    initPage() {
      // TODO
      this.getlcdTagListReq();
      this.getStateListReq();
      this.getList();
    },
    getlcdTagListReq() {
      getCodeList(35)
        .then((res) => {
          const result = parseResp(res);
          if (result.success) {
            this.lcdTagOptions = result.data;
          } else {
            modelUi.msgError(result.message);
          }
        })
        .catch((err) => {
          modelUi.msgError(parseError(err));
        });
    },
    // 获取页面数据
    getList() {
      console.log("获取页面数据");
      const params = {
        ...this.pageParams,
        storeId: localStorage.getItem("storeId"),
      };
      getLcdScheduleList(params).then((res) => {
        console.log(res);
        this.pageParams.total = res.data.data.total;
        this.tableData = res.data.data.records;
      });
    },

    // 分页切换
    changePage() {
      this.getList();
    },

    handleAdd() {
      console.log(123);
      this.$refs.addScheduleRef.open();
    },

    // 以上为营销投放方法

    // 获取列表数据
    getTaskScheduleLogListReq() {
      const {
        current,
        size,
        storeType,
        storeName,
        taskName,
        taskType,
        state,
        startTime,
        endTime,
        startProcessed,
        endProcessed,
        startError,
        endError,
        orders,
      } = this.pageParams;

      let startTimeStr = "";
      if (startTime && startTime.length > 0) {
        startTimeStr = `${startTime[0]},${startTime[1]}`;
      }

      let endTimeStr = "";
      if (endTime && endTime.length > 0) {
        endTimeStr = `${endTime[0]},${endTime[1]}`;
      }

      const startProcessedStr = startProcessed || "";
      const endProcessedStr = endProcessed || "";

      const startErrorStr = startError || "";
      const endErrorStr = endError || "";

      let processed = "";
      if (startProcessedStr && endProcessedStr) {
        processed = `${startProcessedStr},${endProcessedStr}`;
      }

      let erros = "";
      if (startErrorStr && endErrorStr) {
        erros = `${startErrorStr},${endErrorStr}`;
      }

      const data = {
        state,
        startTime: startTimeStr,
        endTime: endTimeStr,
        storeName,
        storeId: getStoreId(),
        storeType,
        taskType,
        taskName,
        processed,
        erros,
        current,
        size,
        orders,
      };
      this.getTaskScheduleLogList(data);
    },

    getStateListReq() {
      getCodeList(49)
        .then((res) => {
          const result = parseResp(res);
          if (result.success) {
            this.stateList = result.data;
          } else {
            modelUi.msgError(result.message);
          }
        })
        .catch((err) => {
          modelUi.msgError(parseError(err));
        });
    },

    getTaskTypeListReq() {
      getCodeList(12)
        .then((res) => {
          const result = parseResp(res);
          if (result.success) {
            let typeList = result.data;
            typeList = typeList.filter(
              (item) => item.codeHelp === "taskSchedule"
            );
            console.log("typeList", typeList);
            this.taskTypeList = typeList;
          } else {
            modelUi.msgError(result.message);
          }
        })
        .catch((err) => {
          modelUi.msgError(parseError(err));
        });
    },

    selection() {
      return this.$refs.tableRows && this.$refs.tableRows.selection.length;
    },
    handleSelectAll() {
      const { isAllSelected } = this.$refs.tableRows.store.states;
      console.log(
        "selection==",
        this.$refs.tableRows.store.states.isAllSelected
      );
      if (isAllSelected) {
        const arr = [];
        selection.forEach((it) => {
          arr.push(...it.children);
        });
        this.selectChild(arr);
      } else {
        this.$refs.tableRows.clearSelection();
      }
    },

    async getTaskScheduleLogList(data) {
      const res = await this.$Api.getTaskScheduleLogList(data);
      this.rows = [];
      this.leng = res.data.total;
      this.pageParams.total = res.data.total;
      this.tableData = res.data.records;
    },
    // 查询错误
    quertError(rows) {
      console.log("任务日志---查询失败数", rows);
      // const { message } = rows;
      rows.type = "task";
      this.$refs.errorsLogDialogRef.openDialog(rows);
    },

    // 删除投放
    handleDelete(row) {
      console.log(row);
      this.currentRow = row;
      this.isVisibleConfirmDialog = true;
      this.currentConfirmType = "DELETEST";
      this.confirmObj = {
        type: this.$t("devices.tips"),
        cancelText: this.$t("devices.cancel"),
        confirmText: this.$t("devices.sure"),
        content: this.$t("lcd.NewAdd.Delete tips"),
        loading: false,
      };
    },

    handleEnd(row) {
      console.log("终止");
      this.currentRow = row;
      this.isVisibleConfirmDialog = true;
      this.currentConfirmType = "ENDST";
      this.confirmObj = {
        type: this.$t("devices.tips"),
        cancelText: this.$t("devices.cancel"),
        confirmText: this.$t("devices.sure"),
        content: this.$t("lcd.NewAdd.End tips"),
        loading: false,
      };
    },
    handelConfirmDialog(val) {
      console.log(val);
      if (val === "confirm") {
        const { currentConfirmType } = this;

        this.confirmObj.loading = true;
        if (currentConfirmType === "ENDST") {
          // 终止营销策略
          this.doEnd();
        }
        if (currentConfirmType === "DELETEST") {
          // 删除营销策略
          this.doDelete();
        }
      } else {
        this.isVisibleConfirmDialog = false;
        this.confirmObj.loading = false;
      }
    },
    doEnd() {
      console.log("end");
      const params = {
        id: this.currentRow.id,
      };
      endLcdSchedule(params).then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          this.$message.success(this.$t("lcd.NewAdd.End st Success"));
          this.getList();
          this.isVisibleConfirmDialog = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    doDelete() {
      console.log("doDelete");
      const params = {
        id: this.currentRow.id,
      };
      deleteLcdSchedule(params).then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          this.$message.success(this.$t("lcd.NewAdd.Delete st Success"));
          this.getList();
          this.isVisibleConfirmDialog = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.task_logs {
  .table-cell__task-type {
    background-color: #f1f1f1;
    border-radius: 14px;
    padding: 2px 16px;
    display: inline-block;
  }

  .table-cell__task-type-icon {
    width: 16px;
    height: 16px;
  }

  .table-cell__task-type-name {
    color: #555555;
    font-size: 14px;
    margin-left: 5px;
  }
  .integration_link {
    color: #000 !important;
    border-radius: 20px;
  }
  .integation_serch {
    margin-left: 10px;
    cursor: pointer;
  }
  .integation_serch:hover {
    color: brown;
  }
  .intergation_picker {
    width: 200px;
  }
}
.icon {
  padding: 6px;
  cursor: pointer;
  .svg-icon {
    width: 23px;
    height: 23px;
  }
}

.text {
  padding: 0 15px;
  font-size: 12px;
}
.table_set {
  border-radius: 6px;
  padding: 15px 0 0;
  background-color: white;
  .select_filter {
    padding-bottom: 15px;
    .table_label_size {
      width: 160px;
      font-size: 16px;
    }
    .table_select {
      width: 214px;
    }
  }
  .icon {
    padding: 6px;
    cursor: pointer;
    .svg-icon {
      width: 23px;
      height: 23px;
    }
  }
  .tb_checkbox {
    vertical-align: middle;
  }
}
.esls-page {
  .flex-between {
    display: flex;
    justify-content: space-between;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
  }
  .card-bg {
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
  }
  &_top ::v-deep {
    padding: 20px;
    margin-bottom: 20px;
    .right-btn,
    .transmit-btn-box {
      .el-button > span {
        // display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .el-button {
      width: 140px;
      // height: 40px;
      height: 34px;
      border-radius: 6px;
      // font-size: 18px;
      padding: 0 16px;
      color: #ffffff;
      i {
        margin-right: 5px !important;
      }
      .el-input {
        height: 100%;
        .el-input__inner {
          height: 100%;
        }
      }
    }
    // transmit下拉框
    .transmit-btn.el-button {
      border: none;
      margin-right: 20px;
      background: #3461ff;
      color: #ffffff;
      border-radius: 6px;
    }
    .danger-btn {
      background: #fc184d;
      color: #ffffff;
    }
    .gray-btn {
      background: #eeeeee;
      border: 1px solid #eeeeee;
      color: #666666;
      width: 80px;
    }
    .top-btn {
      width: 200px;
      text-align: center !important;
    }
  }
  &_content {
    &-top {
      padding: 15px;
      font-size: 12px;
      // color: #999999;
      > span {
        margin-right: 10px;
      }
    }
    &-table ::v-deep {
      .el-table {
        .el-table__header-wrapper {
          .el-table__header {
            width: 100% !important;
          }
        }

        .el-table__header-wrapper,
        .el-table__empty-block {
          width: 100% !important;
        }
      }
      .el-table
        .el-table__header-wrapper
        .el-table__header
        .is-group
        tr:nth-of-type(2)
        th:nth-of-type(1)
        .cell {
        display: none;
      }
      .else-state {
        padding: 3px 18px;
        text-align: center;
        border-radius: 15px;
        display: inline-block;
      }
      .state-red {
        background: rgba(254, 202, 202, 1);
      }

      .state-blue {
        background: rgba(193, 233, 255, 1);
      }
    }
  }
}
</style>
